import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { SofaFormControl, SofaLink } from '@sofology/sofologycomponents';

import './EmploymentDetailsForm.scss';

import { SofaFormComponent } from 'interfaces';
import { IfcApplicationData, IlpQuestionDescriptions, SofaFormCrossValidationHandlerType } from 'models';
import { componentGeneratorHelper, formGeneratorHelper, PropertyValueType, SofaFormType } from 'helpers/dynamicFormHelpers';

const EMPLOYMENT_FORM_KEY = 'employment';

interface OwnProps {
    ifcQuestionSet: IlpQuestionDescriptions;
    ifcApplicationData: IfcApplicationData;
    ref?: React.RefObject<EmploymentDetailsFormType>;
    onGoToStartCheckout: () => void;
    onDynamicFormInitialized: () => void;
}

interface OwnState {
    employmentForm: SofaFormType;
    proccessFormCrossValidation: SofaFormCrossValidationHandlerType;
    formHasInvalidReadonlyControls: boolean;
}

class EmploymentDetailsForm extends Component<OwnProps, OwnState> implements SofaFormComponent<Record<string, PropertyValueType>> {
    constructor(props: OwnProps) {
        super(props);

        let employmentForm = formGeneratorHelper.createSofaForm(
            'employmentForm',
            this.props.ifcQuestionSet[EMPLOYMENT_FORM_KEY].properties,
            (updateStateFunc: any) => this.setState(updateStateFunc),
            () => this.state,
            this.props.ifcApplicationData
        );

        this.state = {
            employmentForm: employmentForm.form,
            formHasInvalidReadonlyControls: false,
            proccessFormCrossValidation: employmentForm.crossValidationHandler
        };
    }

    componentDidMount(): void {
        formGeneratorHelper.validateReadonlyControls(this.props.ifcQuestionSet[EMPLOYMENT_FORM_KEY].properties, this.state.employmentForm)
            .then(invalidControls => {
                if (invalidControls.length) {
                    this.setState({ formHasInvalidReadonlyControls: true }, () => {
                        this.props.onDynamicFormInitialized();
                    });
                }
            }).catch();
    }

    componentDidUpdate(prevProps: Readonly<OwnProps>, prevState: Readonly<OwnState>): void {
        this.state.proccessFormCrossValidation(prevState, this.state);
    }

    render(): JSX.Element {
        const { ifcQuestionSet, ifcApplicationData } = this.props;
        const { formHasInvalidReadonlyControls } = this.state;
        const employmentFieldSet = ifcQuestionSet[EMPLOYMENT_FORM_KEY];

        let formComponents: JSX.Element[] = [];

        if (this.state.employmentForm) {
            formComponents = componentGeneratorHelper.getComponents(this.state.employmentForm, employmentFieldSet.properties, ifcApplicationData);
        }

        return (
            <div className='employment-details-form'>
                <Grid container spacing={3}>
                    {formHasInvalidReadonlyControls && this.renderInvalidReadonlytFieldMessage()}
                    <Grid item xs={12}>
                        <h6 className='employment-details-form__title'>
                            {employmentFieldSet.legend}
                        </h6>
                    </Grid>
                    {formComponents}
                </Grid>
            </div>
        );
    }

    renderInvalidReadonlytFieldMessage(): JSX.Element {
        return (
            <Grid item xs={12}>
                <div className='employment-details-form__readonly-fields-error'>
                    Previously saved information is missing mandatory fields or contains invalid characters.
                    <SofaLink onClick={this.props.onGoToStartCheckout} text='Please go back and enter manually' />
                </div>
            </Grid>
        );
    }

    public validate = (): Promise<SofaFormControl<Record<string, PropertyValueType>>[]> => {
        return this.state.employmentForm.validate();
    };

    public getFormData = (): Record<string, PropertyValueType> => {
        return formGeneratorHelper.extractFormDataToIlpObject(
            this.state.employmentForm,
            this.props.ifcQuestionSet[EMPLOYMENT_FORM_KEY].properties);
    };

    public hasInvalidReadonlyControls = (): boolean => {
        return this.state.formHasInvalidReadonlyControls;
    };
}

export default (EmploymentDetailsForm);
export type EmploymentDetailsFormType = EmploymentDetailsForm;